import './index.scss'
import React, { useCallback } from 'react'
import { logout } from '../../network/request'
import { isXpAPP } from '../../utils/common'

interface Props {
  errorType?: string
  message?: any
  getData?: any
  /** 是否显示切换账号登录按钮 */
  showSwitchAccount?: boolean
}

export default ({ errorType = '请求失败，', message, getData, showSwitchAccount }: Props) => {
  const handleSwitchAccount = useCallback(() => {
    logout()
  }, [])

  return (
    <div className="error">
      <div className="img"></div>
      <p className="tip">
        {errorType}
        {getData ? (
          <span className="retry" onClick={getData}>
            点击重试
          </span>
        ) : null}
      </p>
      {message && <p className="msg">原因：{message}</p>}
      {showSwitchAccount && !isXpAPP() && (
        <span className="switch-account" onClick={handleSwitchAccount}>
          切换账号登录
        </span>
      )}
    </div>
  )
}
